module.exports = __webpack_public_path__ + "img/using_help.6971ea07.svg";